export default __webpack_public_path__ + "static/media/ElenaNDNUv3.60422261.pdf";